module.exports = __webpack_public_path__ + "media/images/umpisa-1bc782b3e0905b9f976a1007a819fc51.png";